import { render, staticRenderFns } from "./footer-default.vue?vue&type=template&id=76328845&scoped=true"
import script from "./footer-default.vue?vue&type=script&lang=js"
export * from "./footer-default.vue?vue&type=script&lang=js"
import style0 from "./footer-default.vue?vue&type=style&index=0&id=76328845&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76328845",
  null
  
)

export default component.exports